
// if (typeof Swiper !== "undefined") {
//     const tiktokSwiper = document.querySelector(".tiktokSwiper");

//     if (tiktokSwiper) {
//         new Swiper(tiktokSwiper, {
//             slidesPerView: 1.8,
//             spaceBetween: 16,
//             loop: true,
//             grabCursor: true,
//             speed: 1000,
//             navigation: {
//                 nextEl: ".swiper-button-next",
//                 prevEl: ".swiper-button-prev",
//             },
//             // autoplay: {
//             //     delay: 3000,
//             //     disableOnInteraction: false,
//             // },
//             pagination: {
//                 el: ".swiper-pagination",
//                 clickable: true,
//             },

//             breakpoints: {
//                 280: {
//                     slidesPerView: 1.3,
//                     spaceBetween: 12,
//                     centeredSlides: true,
//                     loop: true,
//                 },
//                 576: {
//                     slidesPerView: 2,
//                     spaceBetween: 15,
//                 },
//                 769: {
//                     slidesPerView: 3.2,
//                     spaceBetween: 20,
//                 },
//                 1025: {
//                     slidesPerView: 4,
//                     spaceBetween: 20,
//                 },
//                 1200: {
//                     slidesPerView: 4.6,
//                     spaceBetween: 20,
//                 },

//             },
//         });
//     }
// }

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".tiktokSwiper").forEach((slider, index) => {
        const wrapper = slider.querySelector(".swiper-wrapper");
        const slides = slider.querySelectorAll(".swiper-slide");
        const clones = parseInt(slider.dataset.cloneMultiplier, 10) || 2;
        for (let i = 0; i < clones; i++) {
            slides.forEach((s) => wrapper.appendChild(s.cloneNode(true)));
        }
        console.log(
            `Slider #${index + 1}: total slides ${wrapper.querySelectorAll(".swiper-slide").length
            }`
        );
        new Swiper(slider, {
            direction: "horizontal",
            loop: true,
            effect: 'slide',
            speed: 1000,
            // centeredSlides: true,
            grabCursor: true,
            breakpoints: {
                150: { slidesPerView: 1.5, spaceBetween: 10, centeredSlides: true },
                576: { slidesPerView: 2.6, spaceBetween: 15, centeredSlides: true },
                // 768: { slidesPerView: 2.7, spaceBetween: 15, centeredSlides: true },
                900: { slidesPerView: 3.3, spaceBetween: 15, centeredSlides: true },
                1024: { slidesPerView: 3.5, spaceBetween: 20, centeredSlides: true },
                1100: { slidesPerView: 3.9, spaceBetween: 20, centeredSlides: true },
                1200: { slidesPerView: 4, spaceBetween: 20 },
            },
        });
    });
});

document.addEventListener("DOMContentLoaded", function () {
    function faqsAccordion() {
        var accordionSections = document.querySelectorAll(".accordion-item");

        if (accordionSections.length > 0) {
            var firstAccordionItemHeader = accordionSections[0].querySelector(
                ".accordion-item-header"
            );
            var firstAccordionItemBody =
                firstAccordionItemHeader.nextElementSibling;

            if (firstAccordionItemBody) {
                firstAccordionItemHeader.classList.add("active");
                firstAccordionItemBody.style.maxHeight =
                    firstAccordionItemBody.scrollHeight + "px";
            }

            for (let i = 1; i < accordionSections.length; i++) {
                var otherHeader = accordionSections[i].querySelector(
                    ".accordion-item-header"
                );
                var otherBody = otherHeader.nextElementSibling;

                if (otherBody) {
                    otherHeader.classList.remove("active");
                    otherBody.style.maxHeight = "0";
                }
            }
        }

        accordionSections.forEach((section) => {
            var accordionItemHeaders = section.querySelector(
                ".accordion-item-header"
            );
            var accordionItemBody = section.querySelector(".accordion-item-body");

            accordionItemHeaders.addEventListener("click", function () {
                var currentlyActiveHeader = document.querySelector(
                    ".accordion-item-header.active"
                );
                var currentlyActiveBody = currentlyActiveHeader
                    ? currentlyActiveHeader.nextElementSibling
                    : null;

                if (currentlyActiveHeader && currentlyActiveBody) {
                    currentlyActiveHeader.classList.remove("active");
                    currentlyActiveBody.style.maxHeight = 0;
                }

                if (accordionItemHeaders !== currentlyActiveHeader) {
                    accordionItemHeaders.classList.add("active");
                    accordionItemBody.style.maxHeight =
                        accordionItemBody.scrollHeight + "px";
                } else {
                    accordionItemHeaders.classList.remove("active");
                    accordionItemBody.style.maxHeight = 0;
                }
            });
        });
    }

    faqsAccordion();
});


document.addEventListener("DOMContentLoaded", function () {
    const cards = document.querySelectorAll(".tiktok_card");

    cards.forEach(function (card) {
        const video = card.querySelector("video");
        const playBtn = card.querySelector(".play_btn");
        const overlay = card.querySelector(".tiktok_overlay");

        if (!video || !playBtn || !overlay) return;

        playBtn.addEventListener("click", function () {
            // Pause all other videos
            document.querySelectorAll(".tiktok_card video").forEach(function (otherVideo) {
                if (otherVideo !== video) {
                    otherVideo.pause();
                }
            });

            // Play selected video
            video.setAttribute("controls", "controls");
            video.play().then(function () {
                overlay.style.display = "none";
            }).catch(function (error) {
                console.log("Video playback failed:", error);
            });
        });

        video.addEventListener("pause", function () {
            if (!video.ended) {
                overlay.style.display = "flex";
            }
        });

        video.addEventListener("ended", function () {
            overlay.style.display = "flex";
            video.removeAttribute("controls");
        });
    });
})